import React, { Component, cloneElement, PropTypes } from 'react';
import ContractingWindow from './contract-window';
import WaterMark from '../watermark';
import R, { and } from 'ramda';
import { goBack as goBackAction } from 'react-router-redux';
import AddEditContractDialog from '../draftNTemplate-container/add-edit-contract-dialog';
import ProgressBar from './progressIndicatorBar/container';
import { connect } from 'react-redux';
import actions from '../../../../stores/contracting/root-actions-map';
import { onUserInput } from '../../../../stores/userInputActions';
import {
  getContractLeftNav as getContractLeftNavAction,
  getContractDetails as getContractDetailsAction,
  getProductDetails as getProductDetailsAction,
  downloadContractPdf as downloadContractPdfAction,
  getHistoryFeeds as getHistoryFeedsAction,
  clearStore as clearStoreAction,
  createDraft,
} from '../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import { changeContractState as changeContractStateAction } from '../../../../stores/contracting/dashboard/dashboard-actions';
import ResendContract from './dialogs/resend-or-update-dialog';
import CreateDraftDialog from './dialog-create-contract-draft';
import docCookies from '../../../../utils/docCookie';
import { checkLocAccess } from '../../../../middleware/accessCheckHelperFns';
import PublishDraftDialog from '../draftNTemplate-container/publish-draft-dialog';

const getMainTitle = (partnerCompanyName, locationName) => {
  const flipConcat = R.flip(R.concat);
  const lengthGt = gtNum => R.compose(R.lt(gtNum), R.length);
  const composeThreeDotsString = gtNum => R.ifElse(
    lengthGt(gtNum),
    R.compose(flipConcat('...'), R.slice(0, gtNum)),
    R.slice(0, gtNum)
  );
  const composeString = (a, b) => `${a} / ${b}`;
  const companyNameCheck = R.call(composeThreeDotsString(23), partnerCompanyName);
  const hasLocation = R.ifElse(
    R.useWith(and, [lengthGt(23), lengthGt(50)]),
    R.useWith(composeString, [composeThreeDotsString(23), composeThreeDotsString(23)]),
    (company, location) => `${companyNameCheck} / ${R.call(composeThreeDotsString(72 - companyNameCheck.length), location)}`
  );
  return R.ifElse(
    () => !locationName,
    composeThreeDotsString(72),
    hasLocation
  )(partnerCompanyName, locationName);
};
/*
@params pathname = route || location.pathname
 */
const getRouteName = R.cond([
  [R.contains('activities'), R.always('activities')],
  [R.contains('notes'), R.always('notes')],
  [R.contains('product'), R.always('product')],
  [R.contains('policies'), R.always('policies')],
  [R.T, R.always('contractDetails')],
]);

const propTypes = {
  children: PropTypes.object,
  dispatch: PropTypes.func,
  location: PropTypes.object,
  contentLoading: PropTypes.bool,
  leftNavLoading: PropTypes.bool,
  errorOccurs: PropTypes.string,
  leftNav: PropTypes.object,
  rightSideContent: PropTypes.object,
  params: PropTypes.object,
  getContractDetails: PropTypes.func,
  getProductDetails: PropTypes.func,
  changeContractStateTo: PropTypes.func,
  openAddEditContractDialog: PropTypes.func,
  getContractLeftNav: PropTypes.func,
  getHistoryFeeds: PropTypes.func,
  downloadContractPdf: PropTypes.func,
  changeResendContractDialogState: PropTypes.func,
  onClickDiscardRequestsSentToSameName: PropTypes.func,
  clearStore: PropTypes.func,
  companyType: PropTypes.string,
  isShellAccount: PropTypes.bool,
  createDraftDialogOpen: PropTypes.bool,
  toggleCreateDraftDialog: PropTypes.func,
  createDummyTemplateDraft: PropTypes.func,
  readOnly: PropTypes.bool,
  noAccess: PropTypes.bool,
  viewerId: PropTypes.string,
};

class Container extends Component {
  componentWillMount() {
    this.props.dispatch({ type: 'CLOSE_PUBLISH_DRAFT_DIALOG' });
    this.props.getContractLeftNav('contract', this.props.params.contractId)
    .then(this.routeToFirstProductOrSupplierWizard);
    this.props.getHistoryFeeds('contract', this.props.params.contractId);
  }
  componentWillReceiveProps(nextProps) {
    const { getContractLeftNav, params } = nextProps;
    if (this.props.location.query !== nextProps.location.query) {
      getContractLeftNav('contract', params.contractId)
      .then(this.routeToFirstProductOrSupplierWizard);
    }
    if (this.props.leftNav.companyName !== nextProps.leftNav.companyName) {
      document.title = `${getMainTitle(nextProps.leftNav.companyName || nextProps.leftNav.email || '', nextProps.leftNav.locationName || '')} - TourConnect`;
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  componentWillUnmount() {
    docCookies.removeItem('pathname');
    docCookies.removeItem('query');
    this.props.clearStore();
  }
  routeToFirstProductOrSupplierWizard = (newLeftNav) => {
    const { location, params, companyType } = this.props;
    // AUTO route user to the first product page
    const routeName = getRouteName(location.pathname);
    // route to supplier wizard if supplier viewing request
    if (newLeftNav && !newLeftNav.payload.locationId && companyType === 'Supplier' && routeName !== 'activities' && routeName !== 'notes') {
      return this.context.router.replace(`/contracting/supplier-wizard/${params.contractId}`);
    }
    if (routeName === 'contractDetails') {
      const firstProduct = R.path(['payload', 'productsArray', 0], newLeftNav);
      if (!firstProduct) this.context.router.replace(location.pathname.replace('details', 'policies'));
      else {
        const ratePackageId = (() => {
          if (firstProduct._id) return firstProduct._id;
          return firstProduct.ratePackageName
          ? encodeURIComponent(firstProduct.ratePackageName)
          : 'Primary';
        })();
        this.context.router.replace(`/contracting/contract/${params.contractId}/product/${firstProduct.productId}/${ratePackageId}`);
      }
    }
  };
  changeLeftNavRoute = (route) => {
    const { location } = this.props;
    const { router } = this.context;
    if (location.pathname !== route) {
      router.replace(route);
    }
  };
  createNGoToDraft = () => {
    const { leftNav, params, companyType } = this.props;
    const { contractId, productId } = params;
    const { hasDraft, templateHasDraft, templateId } = leftNav;
    if (companyType === 'Supplier' && (hasDraft || templateHasDraft)) {
      const draftId = R.call(R.cond([
        [() => templateHasDraft, R.always(templateId)],
        [R.T, R.always(contractId)],
      ]));
      if (!productId) this.context.router.push(`/contracting/draft/${draftId}/details`);
    } else this.props.toggleCreateDraftDialog();
  };
  render() {
    const { router } = this.context;
    const {
      children,
      params,
      contentLoading,
      leftNavLoading,
      errorOccurs,
      leftNav,
      rightSideContent,
      openAddEditContractDialog,
      changeContractStateTo,
      downloadContractPdf,
      openResendContractDialog,
      openDialogSaveAsTemplate,
      createDummyTemplateDraft,
      isDummyAccount,
      isAnAdmin,
      pureDocView,
      companyType,
      goBack,
    } = this.props;
    const { productId, contractId } = params;
    const { location } = this.props;
    const routeName = getRouteName(location.pathname);
    // if (routeName !== 'activities' && (isNilOrEmpty(rightSideContent) || contentLoading) && !errorOccurs) return <div style={{ marginTop: '150px', textAlign: 'center' }}><CircularProgress size={90} thickness={4} /></div>;
    // const contractState = leftNav.contractState;
    // const acceptedOrLoaded = contractState === 'accepted' || contractState === 'loading' || contractState === 'loaded';
    // const amendmentNeeded = () => {
    //   if (acceptedOrLoaded) return confirm('This contract has already been accepted by both parties. If this contract needs to be updated, an amendment will be created. Do you want to proceed?');
    //   return true;
    // };
    const loading = contentLoading || leftNavLoading;
    const extraProps = {
      reducerName: 'contractActivitiesProducts',
      viewerId: this.props.viewerId,
      // openAddEditContractDialog: R.ifElse(amendmentNeeded, openAddEditContractDialog, () => {}),
      // TODO: fix contractor updates
      productDoesnotExistInDoc: (routeName === 'product' && !loading && R.isNil(rightSideContent.ratePackageIndex)),
      openAddEditContractDialog,
      readOnly: this.props.readOnly,
      isLatest: leftNav.isLatest,
      resendContract: () => openResendContractDialog({
        contractId,
        // this function is only available for the sender
        // for whom partners length should only be one
        partner: R.pathOr({}, ['partners', 0], leftNav),
        to: leftNav.to,
        toEmails: leftNav.toEmails,
        resendToEmails: leftNav.toEmails,
      }),
    };
    const propsForLeftNav = {
      reducerName: extraProps.reducerName,
      location: this.props.location,
      changeLeftNavRoute: this.changeLeftNavRoute,
      goToDashboard: () => {
        if (companyType === 'Contractor') {
          window.location = `${process.env.NEW_SYSTEM_URL}/contracting/${leftNav.locationId ? 'contract' : 'workspace'}-list?jwt=${localStorage.getItem('jwt')}`;
        } else if (localStorage.getItem('lastContractListHref') && localStorage.getItem('lastContractListHref').indexOf('contract-list') > -1) {
          router.push(localStorage.getItem('lastContractListHref'));
        } else {
          router.push('/contracting/contract-list/all%20contracts');
        }
      },
      changeContractStateTo,
      openAddEditContractDialog,
    };
    const shouldHideAppBars = (isDummyAccount && !isAnAdmin)
    || pureDocView;
    return (
      <div
        className={shouldHideAppBars ? 'full-screen-page' : ''}
        style={shouldHideAppBars ? { padding: '0 128px' } : {}}
      >
        {
          Boolean(this.props.readOnly && !loading && leftNav.isLatest) && (<div style={{ textAlign: 'center', marginBottom: '-12px', marginLeft: '4px', fontWeight: 'bold' }}>
            This Contract is READ-ONLY.
          </div>)
        }
        <ProgressBar
          changeContractStateTo={changeContractStateTo}
          resendContract={extraProps.resendContract}
        />
        <ContractingWindow
          routeName={routeName}
          reducerName={extraProps.reducerName}
          actionsForLeftNav={propsForLeftNav}
          actionsForContractWindow={{
            downloadContractPdf,
            resendContract: extraProps.resendContract,
            router,
            changeLeftNavRoute: this.changeLeftNavRoute,
            createNGoToDraft: this.createNGoToDraft,
            onClickDiscardRequestsSentToSameName: this.props.onClickDiscardRequestsSentToSameName,
            openDialogSaveAsTemplate,
          }}
          getMainTitle={getMainTitle}
        >
          { // for CR, don't show watermark
            Boolean(!leftNav.isLatest && !loading && leftNav.locationId) && (<WaterMark
              texts={leftNav.amended ? ['Amended', 'Void', 'Amended', 'Void'] : ['Old Version', 'Void', 'Old Version', 'Void']}
            />)
          }
          {children && !errorOccurs ? cloneElement(children, extraProps) : undefined}
          {
            errorOccurs ? (
              <div style={{ marginTop: '100px', textAlign: 'center', fontSize: '20px' }}>{errorOccurs}</div>
            ) : <div/>
          }
          <ResendContract />
          <PublishDraftDialog forBuyer/>
          <AddEditContractDialog
            reducerName="contractActivitiesProducts"
            router={this.context.router}
          />
          <CreateDraftDialog
            templateId={leftNav.templateId}
            templateFromDummy={leftNav.templateFromDummy}
            companyType={companyType}
            open={this.props.createDraftDialogOpen}
            createSingleDraft={() => {
              this.props.toggleCreateDraftDialog();
              createDraft(contractId, leftNav.templateId, false)
              .then(() => this.context.router.push(`/contracting/draft/${contractId}/details`));
            }}
            createTemplateDraft={() => {
              this.props.toggleCreateDraftDialog();
              createDraft(contractId, leftNav.templateId, true)
              .then(() => this.context.router.push(`/contracting/draft/${leftNav.templateId}/details`));
            }}
            createDummyTemplateDraft={() => createDummyTemplateDraft({
              contractId,
              templateId: leftNav.templateId,
              isDummyTemplate: leftNav.templateFromDummy,
            })}
            onRequestClose={this.props.toggleCreateDraftDialog}
          />
        </ContractingWindow>
      </div>
    );
  }
}

Container.propTypes = propTypes;

const mapStateToProps = ({ contracting, user }) => {
  const contractStore = contracting.contractActivitiesProducts;
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const readOnly = !checkLocAccess({ user }, leftNav.locationId, 'contracting', 'write');
  const noAccess = !checkLocAccess({ user }, leftNav.locationId, 'contracting', 'read');
  return ({
    readOnly,
    noAccess,
    createDraftDialogOpen: contractStore.get('createDraftDialogOpen'),
    contentLoading: contractStore.get('contentLoading'),
    leftNavLoading: contractStore.get('leftNavLoading'),
    errorOccurs: contractStore.get('errorOccurs'),
    leftNav,
    rightSideContent: contractStore.get('rightSideContent').toJS(),
    routeName: contractStore.get('routeName'),
    billingPlan: user.get('billingPlan'),
    contractActivitiesProducts: contractStore.toJS(),
    companyType: user.getIn(['user', 'type']),
    viewerId: user.toJS().company.companyId,
    isShellAccount: user.get('contractingShell') || false,
    isDummyAccount: user.get('isDummyAccount'),
    isAnAdmin: user.get('isAnAdmin'),
    pureDocView: user.get('pureDocView'),
  });
};

const mapDispatchToProps = dispatch => ({
  clearStore: () => dispatch(clearStoreAction()),
  getContractDetails: (...args) => dispatch(getContractDetailsAction(...args)),
  getContractLeftNav: (...args) => dispatch(getContractLeftNavAction(...args)),
  getProductDetails: (...args) => dispatch(getProductDetailsAction(...args)),
  getHistoryFeeds: (...args) => dispatch(getHistoryFeedsAction(...args)),
  changeContractStateTo: (state, ids) => dispatch(changeContractStateAction(state, ids)),
  openAddEditContractDialog: onUserInput(dispatch, actions, 'openAddEditContractDialog'),
  downloadContractPdf: (...args) => dispatch(downloadContractPdfAction(...args)),
  toggleCreateDraftDialog: () => dispatch({ type: '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG' }),
  createDummyTemplateDraft: payload => dispatch({ type: '{dummy-account} CREATE_DUMMY_TEMPLATE_DRAFT', payload }),
  onClickDiscardRequestsSentToSameName: payload => dispatch({ type: 'OPEN_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME', payload }),
  openResendContractDialog: payload =>
    dispatch({
      type: 'CHANGE_RESEND_CONTRACT_DIALOG_STATE',
      payload,
    }),
  openDialogSaveAsTemplate: ({ contractId, contractYear, templateId, isDummyTemplate }) => {
    dispatch({ type: 'OPEN_AS_SAVE_CONTRACT_AS_TEMPLATE', payload: { contractId, contractYear, templateId, isDummyTemplate } });
  },
  goBack: payload => dispatch(goBackAction(payload)),
});

Container.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/contract-container.jsx